import { AlertOverviewEntry, AlertV2Entry } from '@watcherr/resources';
import { AlertReceivedMethodSource, SimpleAlert } from './Alerts.types';
import AlertStore from './Alert';

export const getAlertMethod = (source: AlertReceivedMethodSource): string => {
  switch (source) {
    case AlertReceivedMethodSource.PUSH:
      return 'WEB_PUSH';
    case AlertReceivedMethodSource.API:
      return 'API_REST';
    case AlertReceivedMethodSource.WS:
      return 'API_WEBSOCKET';
  }
};

// These are passed as observer objects, api responses, etc. Create new simple objects that won't be mutated.
export const transformIntoSimpleAlert = (alerts: AlertStore[] | AlertOverviewEntry[] | AlertV2Entry[]): SimpleAlert[] =>
  alerts.map((a) => ({
    uuid: a.uuid,
    priority: a.priority,
    status: a.status,
  }));
